var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refFooterDiv",staticClass:"div-footer",attrs:{"id":"id-div-footer"}},[_c('p',{staticStyle:{"text-align":"center","color":"#666666"}},[_vm._v("\n        恒点信息(hdvrar.com)旗下实用技能学习平台")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#666666"}},[_vm._v("\n        ©2016-"+_vm._s(_vm.endYear)+"\n        版权所有")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1878c3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Footer.vue
// module id = null
// module chunks = 